import React, {useState} from "react";
import TableControls from "./TableControls";
import {isEmpty} from "weed-js";
import {ReportBuilder} from "./ReportBuilder";


export const TableHead = ({
    collapsed,
    onFilterChange,
    onFilterClick,
    onSortClick,
    setCollapsed,
    setShowViewMenu,
    showViewMenu,
    sortStack,
    view,
}) => {
    const columns = (view?.getActiveColumnDefs() || []).sort((a, b) => {
        if (a.getRenderOrder() === null && b.getRenderOrder() === null) {
            return 0;
        }
        if (a.getRenderOrder() === null) {
            return 1; // a is after b
        }
        if (b.getRenderOrder() === null) {
            return -1; // b is after a
        }
        return a.getRenderOrder() - b.getRenderOrder();
    }).map(columnDef => {
        const found = (view?.getActiveColumnDefs() || []).find(col => col.getIndex() === columnDef.getIndex() && col.getRenderOrder() !== null);
        const isVisible = !isEmpty(found);
        return columnDef.render(
            {
                sortStack,
                onSortClick,
                onFilterChange,
                onFilterClick,
                isVisible: isVisible,
                collapsed: collapsed?.[columnDef.getIndex()] || false,
                setCollapsed: (collapsed) => {
                    setCollapsed(prev => ({
                        ...prev,
                        [columnDef.getIndex()]: collapsed
                    }));
                }
            }
        );
    });

    const maxHeight = view?.getActiveColumnDefs().reduce((maxHeight, column) => {
        if (column.style && column.style.height) {
            return Math.max(maxHeight, parseFloat(column.style.height));
        }
        return maxHeight;
    }, 0);

    const props = maxHeight > 0 ? {style: {height: `${maxHeight}px`}} : {};

    return (<thead className={"canold-table-head"}>
        <tr {...props} className={"canold-table-head-tr"}>
            <td colSpan={view?.getActiveColumnDefs().length || 0}>
                <ReportBuilder
                    view={view}
                    showViewMenu={showViewMenu}
                    setShowViewMenu={setShowViewMenu}
                />
            </td>
        </tr>
        <tr {...props} className={"canold-table-head-tr"}>
            {columns}
        </tr>
    </thead>);
};
